/* -------------------------------------------------------------------------- */
/*                                Schema Images                              */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const image = new schema.Entity('images', {}, { idAttribute: 'imageId' });
export const images = new schema.Array(image);
